import { Head } from "@inertiajs/react"
import { FileX2 } from "lucide-react"
import { UserLayout } from "@/components/layouts/user-layout"
import { ScreenHeader } from "@/components/ui/headers"
import { t } from "@/lib/i18n"

/**
 * The one answer the self-invoicing portal gives a request it will not serve.
 *
 * **It takes no props, and that is the point.** The server distinguishes six
 * reasons a bill cannot be invoiced — the token matches nothing, the restaurant
 * does not stamp CFDIs, it has no PAC credential, nothing has settled, somebody
 * already invoiced it, the month closed — and hands a stranger the same screen
 * for every one of them. A restaurant name or a "this was already invoiced"
 * here would turn the endpoint into a map of which restaurants are live and
 * which sales are claimed, drawn one request at a time. See
 * `User::InvoicesController`; `spec/requests/user/invoices_controller_spec.rb`
 * proves the responses are identical by comparing them to each other.
 *
 * So the copy points at the restaurant, which is the only party that can
 * actually tell this diner which of the six happened.
 */
export default function UserInvoicesUnavailable() {
  return (
    <UserLayout>
      {/* The generic title, like everything else on this screen: a document
          title naming the restaurant or the reason would leak exactly what the
          six identical responses above exist to hide. */}
      <Head title={t("ui.react.pages.user.invoices.unavailable.title")} />

      <div data-testid="self-invoice-unavailable-view">
        <ScreenHeader title={t("ui.react.pages.user.invoices.unavailable.title")} />

        <div className="w-full px-4 pb-10 pt-4">
          <div className="flex flex-col items-center gap-3 rounded-2xl border bg-card px-5 py-10 text-center">
            <FileX2 className="size-6 text-muted-foreground" />
            <p className="text-sm text-muted-foreground">
              {t("ui.react.pages.user.invoices.unavailable.body")}
            </p>
          </div>
        </div>
      </div>
    </UserLayout>
  )
}
